
import type { PropType } from 'vue';

import { defineComponent } from 'vue';

import type { Site } from '@/types';

export default defineComponent({
  props: {
    site: {
      type: Object as PropType<Site>,
      required: true,
    },
  },
});
